<template>
	<RightDrawer title="下沉一线交接班信息" :visible.sync="visible">
		<template slot="content">
			<div class='content_p'>
				<p >姓名：{{details.username}}</p>
				<p>部门：{{details.depart}}</p>
				<p>岗位：{{details.role}}</p>
				<p>交接班记录详情：{{details.visit_date}}</p>
			</div>
			<a-timeline>
				<a-timeline-item color="gray" v-for='(item,index) in details.list' :key='index'>
					<div class='content_p'>
						<p>交接地址：{{item.create_time}}</p>
					<p>交接地址：{{item.address}}</p>
					<p>备注内容：{{item.remark}}</p>
					<p>交接照片：{{item.image_num}}张</p>	
					</div>
					<div>
						<LookImages :list="item.image" :is_img="true"></LookImages>
					</div>
				</a-timeline-item>
			</a-timeline>
		</template>
	</RightDrawer>
</template>

<script>
	import {
		getMonthHandOverDetail
	} from "@/api/supervision";
	import RightDrawer from "@/components/RightDrawer";
	import LookImages from "@/components/LookImages";
	export default {
		components: {
			RightDrawer,
			LookImages
		},
		props: {

		},
		data() {
			return {
				list: [{}, {}, {}],
				imgs: [{}],
				visible: false,
				details: {
					list: [],
				},
			}
		},
		methods: {
			get_details(item, index) {
				getMonthHandOverDetail({
					data: {
						uid: item.uid,
						visit_month: item.visit_date||item.visit_month
					}
				}).then(res => {
					this.details = res.data.list;
					this.visible = true;
				})
			},
		}

	}
</script>
<style lang="less">
	
	.content_p{
		p{
			margin:5px 0;
		}
		margin-bottom:20px;
	}
</style>